import React, { useState, useEffect, useRef } from 'react';
import { Box, Flex, Button, Center, Text, useColorMode, Badge, Heading, VStack, AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay, useToast, Spinner, Spacer } from '@chakra-ui/react';
import { Stat } from '../components/dashboard/Stat';
import { useAuth } from '../context/AuthContext';
import useHttp from '../utils/http';
import Form from '../components/Form/Form';
import TablePerTag from '../components/TablePerTag';
import TablePerSKU from '../components/TablePerSKU';
import { useGlobalContext } from '../context/GlobalContext';
import { useNavigate } from 'react-router-dom';
//import Login from './Login';

const Operations = () => {
    const { post, put, refreshToken, isRefreshing } = useHttp();
    const [isReading, setIsReading] = useState(false);
    const [locationSelected, setLocationSelected] = useState(null);
    const [orderSelected, setOrderSelected] = useState(null);
    const [isFormCompleted, setIsFormCompleted] = useState(false);
    const [, setOrderDetails] = useState([{}]);
    const [orderDetailsCopy, setOrderDetailsCopy] = useState([{}]);
    const [operation, setOperation] = useState(null);
    const [espected, setEspected] = useState(0);
    const [found, setFound] = useState(0);
    const [missing, setMissing] = useState(0);
    const [added, setAdded] = useState(0);
    const [total, setTotal] = useState(0);
    const [dataTableTag, setDataTableTag] = useState([]);
    const [webSocket, setWebSocket] = useState(null);
    const { colorMode } = useColorMode();
    const { userDetails } = useAuth();
    const background = colorMode === "light" ? "gray.50" : "gray.800";
    const clockRef = useRef();
    const [summary, setSummary] = useState([]);
    const [operationDetails, setOperationDetails] = useState({});
    const [printedTags, setPrintedTags] = useState([]);
    const [{ config }, dispatch] = useGlobalContext();
    const [isOpen, setIsOpen] = useState(false);
    const [isDisabled, setIsDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedOrderInformation, setSelectedOrderInformation] = useState(null);
    const [alertMessage, setAlertMessage] = useState('');
    const onClose = () => setIsOpen(false);
    const cancelRef = useRef();
    let indexToRemoveState = useRef(-1);
    const toast = useToast();
    const navigate = useNavigate();
    const readedTags = [];

    const animationsStyle = `
        @keyframes blink {
            50% {
                opacity: 0;
            }
        }

        @keyframes movingGradient {
            0% { background-position: 0% 50%; }
            50% { background-position: 100% 50%; }
            100% { background-position: 0% 50%; }
        }
    `;

    const stats = [
        { label: 'Esperados', value: espected, color: 'gray.500' },
        { label: 'Encontrados', value: found, limit: espected, color: 'green' },
        { label: 'Faltantes', value: missing, limit: espected, color: 'red' },
        { label: 'Agregados', value: added, color: 'yellow' },
        { label: 'Totales', value: total, color: 'blue' }
    ];

    // Bloquear la salida de la página y preguntar si realmente quiere salir
    useEffect(() => {
        const handleBeforeUnload = (e) => {
            e.preventDefault();
            e.returnValue = '';
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, []);

    // Reloj
    useEffect(() => {
        const formattedTime = (date) => `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;

        const updateClock = () => {
            if (clockRef.current) {
                clockRef.current.textContent = formattedTime(new Date());
            }
        };

        const intervalId = setInterval(updateClock, 1000);

        // Initialize clock
        updateClock();

        // Cleanup function to clear the interval
        return () => clearInterval(intervalId);
    }, []);

    // Refrescar token para evitar que expire durante el proceso
    useEffect(() => {
        refreshToken();
        // eslint-disable-next-line
    }, []);

    // Calcular la cantidad de unidades esperadas en la orden
    useEffect(() => {
        function sumQuantities(orderData) {
            if (!orderData || !orderData.details) {
                return 0;
            }
            return orderData.details.reduce((sum, item) => {
                return sum + parseInt(item.qty, 10);
            }, 0);
        }
        const summary = sumQuantities(orderDetailsCopy[0]);
        setEspected(summary);
        // eslint-disable-next-line
    }, [isFormCompleted]);

    // Resumir la orden y calcular las cantidades encontradas, agregadas y faltantes
    useEffect(() => {
        const result = summarizeOrder(orderDetailsCopy[0], dataTableTag);
        setSummary(result);
        const summary = summarizeQuantities(result);
        setFound(summary.found);
        setAdded(summary.added);
        setMissing(summary.missing);
        setTotal(summary.found + summary.added);
    }, [orderDetailsCopy, dataTableTag]);

    // Resumir las cantidades encontradas, agregadas y faltantes
    function summarizeQuantities(items) {
        return items.reduce((totals, item) => {
            totals.found += item.foundQty;
            totals.added += item.added;
            totals.missing += item.missing;
            return totals;
        }, { found: 0, added: 0, missing: 0 });
    }

    // Crea el objeto resultado de los detalles de la operación
    useEffect(() => {
        setOperationDetails({
            operator: { userName: userDetails?.name, userEmail: userDetails?.email },
            location: locationSelected?.name,
            order: orderSelected,
            operation: operation,
            espected: espected,
            startTime: null,
            endTime: null,
            otherTimes: []
        });
        // eslint-disable-next-line
    }, [locationSelected, orderSelected, operation, espected]);

    // Busca los tags en la lista de tags impresos
    const epcLookUp = (epc) => printedTags.find(tag => tag.epc.toUpperCase() === epc.toUpperCase());

    // Prende baliza dependiendo del estado de lectura
    /*     const turnOnOffLights = (status) => {
            const body = {
                status: status,
                location: locationSelected.name
            };
            post('/api/operations/lights', body);
        }; */




    // Manejar el inicio y detención de la lectura
    const handleReadingDown = async () => {
        const newReadingStatus = !isReading;

        if (newReadingStatus) {
            // Start Reading: Establish WebSocket Connection
            try {
                const ws = new WebSocket(process.env.REACT_APP_BACKEND_WS);

                ws.onopen = () => {
                    console.log('WebSocket connection established', locationSelected); //el location y el id de la bd donde esa configuracion, no es importante el id, no tiene que ver con el websocket
                    ws.send(JSON.stringify({ message: 'Start Reading', location: locationSelected }));
                    setOperationDetails(prevOperationDetails => {
                        const operationDetails = { ...prevOperationDetails };
                        if (!operationDetails.startTime) {
                            return { ...prevOperationDetails, startTime: new Date().toISOString() };
                        } else {
                            return { ...operationDetails, otherTimes: [...operationDetails.otherTimes, { start: new Date().toISOString() }] };
                        }
                    });
                };

                ws.onmessage = (event) => {
                    let serial, sku, epc, printedTimestamp;
                    const data = JSON.parse(event.data);
                    console.log("Dato para el location: ", data.topic);
                    console.log("Este es el location: ", locationSelected.name);
                    if (data.topic !== locationSelected.name) {
                        console.log("No se usa el dato porque es para otro location");
                        return;
                    }
                    console.log("Dato recibido de Lector: ", data.idHex);
                    console.log("array de tags recibidos:", readedTags);
                    if (readedTags.includes(data.idHex)) {
                        console.log("No se usa porque ya se recibio ese tag");
                        return;
                    }
                    readedTags.push(data.idHex);
                    //console.log("Selected DB type CONFIG: ", config?.type);
                    // Se configura si los datos de la etiqueta se buscan en BD o se obtienen de la etiqueta misma
                    if (config?.type === "DB") {
                        const tag = epcLookUp(data.idHex);
                        if (!tag) {
                            console.log("Tag no encontrado");
                            toast({
                                title: 'Tag no encontrado',
                                description: "El tag no se encuentra en la lista de tags impresos",
                                status: 'error',
                                duration: 9000,
                                isClosable: true,
                            });
                            return;
                        }
                        console.log("--------------Tag encontrado---------------", tag);
                        sku = tag.sap;
                        serial = tag.serial;
                        epc = tag.epc;
                        printedTimestamp = tag.createdAt;
                    } else {
                        sku = data.sku;
                        serial = data.serial;
                    }
                    console.log(data);
                    console.log("SKU:", sku);
                    console.log("Serial:", serial);
                    processOrder(sku, serial, epc, printedTimestamp);
                };

                ws.onerror = (error) => {
                    console.error('WebSocket error:', error);
                };

                ws.onclose = () => {
                    console.log('WebSocket connection closed');
                    setOperationDetails(prevOperationDetails => {
                        const operationDetails = { ...prevOperationDetails };
                        if (!operationDetails.endTime) {
                            return { ...prevOperationDetails, endTime: new Date().toISOString() };
                        } else {
                            return { ...operationDetails, otherTimes: [...operationDetails.otherTimes, { end: new Date().toISOString() }], endTime: new Date().toISOString() };
                        }
                    });
                };
                // Store WebSocket reference in state or context for later use
                setWebSocket(ws);
            } catch (error) {
                console.error('Error establishing WebSocket connection:', error);
            }
        } else {
            if (webSocket) {
                webSocket.close();
                setWebSocket(null);
                console.log('WebSocket connection closed');
            }
        }

        setIsReading(newReadingStatus);

        try {
            const body = {
                workflowName: locationSelected.name,
                _id: locationSelected.id,
                activeStatus: newReadingStatus
            };

            await put('/api/operations/workflow', body);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                toast({
                    title: 'Se ha cerrado la sesión',
                    description: "Ingrese de nuevo para continuar",
                    status: 'success',
                    duration: 9000,
                    isClosable: true,
                });
            } else {
                console.error("Error al cambiar el estado del lector", error);
            }
        }
    };

    /**
     * Process an order by updating the quantity of a specific item.
     * If the item is found in the order, its quantity will be decreased by 1.
     * If the item is not found, it will be added to the order with a quantity of 1.
     * @param {string} sku - The SKU of the item to process.
     * @param {string} serialNumber - The serial number of the item to process.
     * @returns {Array} - The updated order details.
     */

    function processOrder(sku, serialNumber, epc, printedTimestamp) {
        console.log("entro a procesar el tag", sku, serialNumber);

        setOrderDetails(prevOrderDetails => {
            const order = prevOrderDetails[0];
            let itemIndex;
            try {
                itemIndex = order.details.findIndex(item => item.sku === sku && item.qty === 1);
            } catch (error) {
                console.log(error);
                return;
            }
            const item = { ...order.details[itemIndex] };
            delete item.qty;
            if (itemIndex >= 0 && parseInt(order.details[itemIndex].qty) > 0) {
                // Found the item, update its quantity
                const newQty = parseInt(order.details[itemIndex].qty) - 1;
                const newDetails = [...order.details];
                newDetails[itemIndex] = { ...newDetails[itemIndex], qty: newQty.toString() };
                const item = { ...order.details[itemIndex] };
                delete item.qty;
                postToDataTable(sku, serialNumber, item, epc, printedTimestamp);
                return [{ ...order, details: newDetails }];
            } else {
                // Item not found in the order, add it to the data table with an error
                postToDataTable(sku, serialNumber, item, epc, printedTimestamp, { error: "no estaba en la orden" });
                return prevOrderDetails;
            }
        });
    }

    function postToDataTable(sku, serialNumber, item, epc, printedTimestamp, error) {
        console.log("entro a postToDataTable con error", error);
        console.log("postToDataTable: ", sku, serialNumber, item);
        const newItem = { ...item, sku, serialNumber, epc, printedTimestamp, datetime: new Date().toISOString(), error };
        setDataTableTag(prevDataTableTag => {
            // Check if the item already exists in the array
            const isItemExists = prevDataTableTag.some(tagItem =>
                tagItem.serialNumber === newItem.serialNumber && tagItem.sku === sku);

            if (!isItemExists) {
                // If the item does not exist, add it to the array and sort
                const updatedDataTableTag = [...prevDataTableTag];
                updatedDataTableTag.unshift(newItem);
                return updatedDataTableTag;
            } else {
                return prevDataTableTag;
            }
        });
    }

    function summarizeOrder(orderDetailCopy, dataTable) {
        console.log("OrderDetailCopy", orderDetailCopy);
        if (!orderDetailCopy || !orderDetailCopy?.details) {
            console.log("Error en summarizeOrder");
            return [];
        }
        console.log("Entro a sumarizar Orden");

        // Agrupar las cantidades por SKU
        const skuMap = orderDetailCopy.details.reduce((map, detail) => {
            if (map.has(detail.sku)) {
                map.get(detail.sku).orderedQty += parseInt(detail.qty, 10);
            } else {
                map.set(detail.sku, {
                    sku: detail.sku,
                    orderedQty: parseInt(detail.qty, 10)
                });
            }
            return map;
        }, new Map());

        const uniqueSkus = new Set([...skuMap.keys(), ...dataTable.map(item => item.sku)]);

        console.log("Unique sku", uniqueSkus);
        return Array.from(uniqueSkus).map(sku => {
            const detail = skuMap.get(sku);
            const orderedQty = detail ? detail.orderedQty : 0;

            let totalFound = dataTable.reduce((count, item) => item.sku === sku ? count + 1 : count, 0);

            const foundQty = Math.min(totalFound, orderedQty);
            const added = totalFound > foundQty ? totalFound - foundQty : 0;

            return {
                sku,
                orderedQty,
                foundQty,
                added,
                status: foundQty === orderedQty ? 'Sufficient' : 'Insufficient',
                missing: orderedQty - foundQty,
                exclusiveToDataTable: !detail,
            };
        });
    }

    const removeItem = (indexToRemove) => {
        indexToRemoveState.current = indexToRemove;
        setAlertMessage("Eliminar")
        setIsOpen(true);
    };

    const confirmRemoval = () => {
        setDataTableTag(dataTableTag.filter((item, index) => index !== indexToRemoveState.current));
        onClose();
    };

    const handleFinishOrder = async (data) => {
        setIsLoading(true);
        try {
            await post('/api/operations/result', data);
            setIsLoading(false);
            setIsDisabled(true);
            toast({
                title: 'Orden Finalizada',
                description: "Envio correcto",
                status: 'success',
                duration: 9000,
                isClosable: true,
            });
            dispatch({
                type: 'UPDATE_CONFIG',
                payload: { inOperation: false }
            });
        } catch (error) {
            setIsLoading(false);
            toast({
                title: 'Error al enviar los resultados',
                description: error.message,
                status: 'error',
                duration: 9000,
                isClosable: true,
            });
        }
    };

    const handleCancel = () => {
        setAlertMessage("Cancelar")
        setIsOpen(true);
    };

    const confirmCancel = () => {
        dispatch({
            type: 'UPDATE_CONFIG',
            payload: { inOperation: false }   //Pone en false la variable inOperation en el contexto global para permitir el uso de menus
        });
        navigate("/dashboard");
    };
    //if (config?.isTokenValid === false) {
    //    console.log("Token invalido, llamando LOGIN");
    //    return <Login />
    if (isFormCompleted) {
        if (!isLoading && !isRefreshing) {
            return (
                <>
                    <AlertDialog
                        isOpen={isOpen}
                        leastDestructiveRef={cancelRef}
                        onClose={onClose}
                    >
                        <AlertDialogOverlay>
                            <AlertDialogContent>
                                <AlertDialogHeader fontSize="lg" fontWeight="bold">
                                    {`Confirmar ${alertMessage}`}
                                </AlertDialogHeader>

                                <AlertDialogBody>
                                    {`¿Estás seguro de que quieres ${alertMessage}? Esta acción no se puede deshacer.`}
                                </AlertDialogBody>

                                <AlertDialogFooter>
                                    <Button ref={cancelRef} onClick={onClose}>
                                        No
                                    </Button>
                                    <Button colorScheme="red" onClick={alertMessage === 'Cancelar' ? confirmCancel : confirmRemoval} ml={3}>
                                        {`Sí, ${alertMessage}`}
                                    </Button>
                                </AlertDialogFooter>
                            </AlertDialogContent>
                        </AlertDialogOverlay>
                    </AlertDialog>
                    <style>
                        {animationsStyle}
                    </style>
                    <Flex
                        wrap="wrap"
                        justifyContent="space-around"
                        mt='2%'
                        w='100%'
                        h='95vh'
                    >
                        <Box w='100%' h='5%' border='1px' borderColor='gray.200' bg={background} m='4' p={8} rounded='10px'>
                            <Flex alignItems='center' justifyContent='space-between' height='100%'>
                                <Box><Center><Badge fontSize='3ch' mr={"5%"} >Orden</Badge><Badge fontSize='3ch' color='red' ml='10px' >{orderSelected}</Badge></Center></Box>
                                <Badge fontSize='lg' colorScheme={isReading ? 'green' : 'red'}>{isReading ? "EN PROCESO" : "DETENIDA"}</Badge>
                                <Box><Center><Badge fontSize='lg' colorScheme='blue'>{operation}</Badge><Badge ml='10px' fontSize='lg' colorScheme='blue'>{locationSelected.name}</Badge></Center></Box>
                                <Text fontSize='30px' fontFamily='monospace' ref={clockRef}></Text>
                            </Flex>

                        </Box>
                        {!isDisabled && <Box
                            onClick={() => handleReadingDown()}
                            w='100%'
                            h='min-content'
                            border='1px'
                            borderColor='gray.200'
                            p='3'
                            bg={isReading ? "red.200" : "linear-gradient(90deg, rgba(0,255,0,1) 0%, rgba(0,0,255,1) 100%)"}
                            ml='4'
                            mr='4'
                            rounded='10px'
                            sx={{
                                animation: isReading ? 'blink 1s linear infinite' : 'movingGradient 3s ease infinite',
                                backgroundSize: '200% 200%'
                            }}
                        >
                            <Center>
                                <Heading fontSize='2xl' fontFamily='monospace'>
                                    {isReading ? "Detener" : "Iniciar"}
                                </Heading>
                            </Center>
                        </Box>}

                        {stats.map((stat, id) => (
                            <Box key={id} w={{ base: "100%", md: "50%", lg: "20%" }} p={4}>
                                <Stat  {...stat} />
                            </Box>
                        ))}
                        <Flex
                            h="100vh"
                            alignItems="flex-start"
                            direction={{ base: "column", md: "row" }}
                            justifyContent="space-between"
                            w="100%"
                            margin={{ base: "4", md: "0" }}
                        >
                            <Box
                                w={{ base: "100%", md: "48%" }}
                                h="55%"
                                border="1px"
                                borderColor="gray.200"
                                bg={background}
                                m="4"
                                p={4}
                                rounded="10px"
                            >
                                <TablePerTag data={dataTableTag} tableNumber={1} tableSize={10} removeItem={removeItem} />
                            </Box>
                            <Box
                                w={{ base: "100%", md: "48%" }}
                                h="55%"
                                border="1px"
                                borderColor="gray.200"
                                bg={background}
                                m="4"
                                p={4}
                                rounded="10px"
                            >
                                <TablePerTag data={dataTableTag} tableNumber={2} tableSize={10} removeItem={removeItem} last />
                            </Box>
                            <VStack w="100%" m="4">
                                <Box
                                    w="100%"
                                    border="1px"
                                    borderColor="gray.200"
                                    bg={background}
                                    p={4}
                                    rounded="10px"
                                >
                                    <TablePerSKU summary={summary} />
                                </Box>
                                {dataTableTag.length > 0 && !isReading && !isDisabled && (
                                    <Box
                                        onClick={() =>
                                            handleFinishOrder({
                                                data: dataTableTag,
                                                operation,
                                                operationDetails,
                                                found,
                                                added,
                                                missing,
                                                total,
                                                selectedOrderInformation,
                                            })
                                        }
                                        w="100%"
                                        border="1px"
                                        borderColor="gray.200"
                                        bg={
                                            colorMode === "light"
                                                ? "rgba(120, 235, 82, 0.5)"
                                                : "rgba(120, 235, 82, 0.5)"
                                        }
                                        p={4}
                                        rounded="10px"
                                    >
                                        <Center>
                                            <Text fontSize={"4xl"}>Enviar Resultados</Text>
                                        </Center>
                                    </Box>
                                )}
                                {isDisabled && (
                                    <Box
                                        onClick={() => navigate("/dashboard")}
                                        w="100%"
                                        border="1px"
                                        borderColor="gray.200"
                                        bg={
                                            colorMode === "light"
                                                ? "rgba(120, 235, 82, 0.5)"
                                                : "rgba(120, 235, 82, 0.5)"
                                        }
                                        p={4}
                                        rounded="10px"
                                    >
                                        <Center>
                                            <Text fontSize={"4xl"}>Finalizar</Text>
                                        </Center>
                                    </Box>
                                )}
                                <Spacer mt='8%' />
                                {!config?.inOperaton && !isReading && !isDisabled && (
                                    <Box
                                        onClick={() => handleCancel()}
                                        w="100%"
                                        border="1px"
                                        borderColor="gray.200"
                                        bg={
                                            colorMode === "light"
                                                ? "rgba(255, 0, 0, 0.5)"  // Red color with 50% transparency
                                                : "rgba(255, 0, 0, 0.5)"  // Red color with 50% transparency
                                        }

                                        p={2}
                                        rounded="10px"
                                    >
                                        <Center>
                                            <Text fontSize={"4xl"}>Cancelar</Text>
                                        </Center>
                                    </Box>
                                )}
                            </VStack>
                        </Flex>
                    </Flex>
                </>
            );
        } else {
            return (
                <Center height="100vh" width="100%">
                    <Spinner size="xl" thickness="6px" speed="0.65s" emptyColor="gray.200" color="blue.500" width="150px" height="150px" />
                </Center>
            );
        }
    } else {
        return (
            <Form
                userDetails={userDetails}
                setOrderSelected={setOrderSelected}
                setSelectedOrderInformation={setSelectedOrderInformation}
                setPrintedTags={setPrintedTags}
                setLocationSelected={setLocationSelected}
                setIsFormCompleted={setIsFormCompleted}
                setOperation={setOperation}
                setOrderDetails={setOrderDetails}
                setOrderDetailsCopy={setOrderDetailsCopy}
            />
        );
    }
    // }
};

export default Operations;
